import {
    banner1, footer1, header1, mostViewed1, popular1, recommend1,
    banner2, footer2, header2, mostViewed2, popular2, recommend2,
    banner3, footer3, header3, mostViewed3, popular3, recommend3,
    banner4, footer4, header4, mostViewed4, popular4, recommend4
} from '/public/siteImages/iOSTheme/explore';

export function getExploreTheme({ places, recommend, banner, mostViewed, placesOrder, recommendOrder, mostViewedOrder, bannerOrder, themeType }) {
    const exploreArray = [
        {
            themeType: places,
            order: placesOrder,
            name: 'places'
        },
        {
            themeType: recommend,
            order: recommendOrder,
            name: 'recommend'
        },
        {
            themeType: banner,
            order: bannerOrder,
            name: 'banner'
        },
        {
            themeType: mostViewed,
            order: mostViewedOrder,
            name: 'mostViewed'
        }
    ];

    exploreArray?.sort((a, b) => a?.order - b?.order);

    let themes = [];

    if (themeType == 1) themes.push(header1);
    else if (themeType == 2) themes.push(header2);
    else if (themeType == 3) themes.push(header3);
    else if (themeType == 4) themes.push(header4);

    exploreArray?.map(async (item) => {

        if (item.themeType == 1) {
            if (item.name == 'places') themes.push(popular1);
            else if (item.name == 'recommend') themes.push(recommend1);
            else if (item.name == 'banner') themes.push(banner1);
            else if (item.name == 'mostViewed') themes.push(mostViewed1);
        }

        else if (item.themeType == 2) {
            if (item.name == 'places') themes.push(popular2);
            else if (item.name == 'recommend') themes.push(recommend2);
            else if (item.name == 'banner') themes.push(banner2);
            else if (item.name == 'mostViewed') themes.push(mostViewed2);
        }

        else if (item.themeType == 3) {
            if (item.name == 'places') themes.push(popular3);
            else if (item.name == 'recommend') themes.push(recommend3);
            else if (item.name == 'banner') themes.push(banner3);
            else if (item.name == 'mostViewed') themes.push(mostViewed3);
        }

        else if (item.themeType == 4) {
            if (item.name == 'places') themes.push(popular4);
            else if (item.name == 'recommend') themes.push(recommend4);
            else if (item.name == 'banner') themes.push(banner4);
            else if (item.name == 'mostViewed') themes.push(mostViewed4);
        }
    });

    if (themeType == 1) themes.push(footer1);
    else if (themeType == 2) themes.push(footer2);
    else if (themeType == 3) themes.push(footer3);
    else if (themeType == 4) themes.push(footer4);

    return themes;
}


